import { render, staticRenderFns } from "./feedBackList.vue?vue&type=template&id=1d0b8a68&"
import script from "./feedBackList.vue?vue&type=script&lang=ts&"
export * from "./feedBackList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports